import { useState } from "react";
import { ArrowSquareOut, LockSimple } from "@phosphor-icons/react";
import { fetchRedirectLink, trackAffiliateClick } from "@/lib/api";

// Shown instead of the YouTube iframe for titles YouTube won't play on other sites.
export const RedirectFallback = ({ video }) => {
  const [busy, setBusy] = useState(false);
  const img = video.tmdb_backdrop || video.default_thumb || video.tmdb_poster;
  const go = async () => {
    setBusy(true);
    const win = window.open("about:blank", "_blank");
    try {
      const { url } = await fetchRedirectLink(video.video_id);
      trackAffiliateClick({ provider: "justwatch-redirect", video_id: video.video_id, title: video.title });
      if (win) win.location.href = url;
      else window.location.href = url;
    } catch {
      win?.close();
    } finally {
      setBusy(false);
    }
  };
  return (
    <div data-testid="redirect-fallback" className="absolute inset-0">
      {img && <img src={img} alt={video.title} className="h-full w-full object-cover" />}
      <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 bg-gradient-to-t from-black/90 via-black/55 to-black/30 px-6 text-center">
        <p className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-white/60">
          <LockSimple size={14} weight="bold" /> This title only plays on official services
        </p>
        <button
          type="button"
          data-testid="redirect-cta-btn"
          onClick={go}
          disabled={busy}
          className="flex items-center gap-2.5 bg-amber px-7 py-4 font-mono text-xs font-bold uppercase tracking-[0.18em] text-black shadow-[0_10px_40px_rgba(255,170,0,0.35)] transition-transform duration-300 hover:scale-[1.04] focus:outline-none focus:ring-2 focus:ring-white disabled:opacity-60"
        >
          Watch via JustWatch <ArrowSquareOut size={16} weight="bold" />
        </button>
        <p className="font-mono text-[10px] text-white/40">Find where to stream, rent or buy it</p>
      </div>
    </div>
  );
};
